import Alpine from "alpinejs";
import Bugsnag from "@bugsnag/js";
import process from "process";

window.Alpine = Alpine;

Alpine.start();

if (process.env.MIX_BUGSNAG_API_KEY) {
  Bugsnag.start({
    apiKey: process.env.MIX_BUGSNAG_API_KEY,
    enabledReleaseStages: ["production", "staging"],
    appVersion: process.env.MIX_APP_TAG,
    releaseStage: process.env.MIX_APP_ENV,
  });
}
